import {BehaviorSubject} from 'rxjs';
import {toast} from '@px/helper/toast';
import {userApi} from '@px/api/user';
import {contractApi} from '@px/api/contract-biz';

export const preference$ = new BehaviorSubject<Preference>({});

export async function loadPreference() {
  const {data, error} = await userApi.getPreference();
  if (data) {
    preference$.next(data);
  }
  if (error) {
    toast.error(error);
  }
}

export function resetPreference() {
  preference$.next({});
}

export async function updatePreference(name: string, operation: boolean) {
  const {data, error} = await userApi.modifyPreference({name, operation});
  if (data) {
    preference$.next(data);
  }
  if (error) {
    toast.error(error);
  }
}

export async function updateTpslMode(params: {symbol: string; mode: TpslCloseMode}) {
  const {error} = await contractApi.tpslModeUpdate(params);
  if (error) {
    toast.error(error);
  }
}
